import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export { GTM_EVENTS } from './types';

const state = () => ({
  // Scroll tracking
  hasTriggeredScroll: false,
  scrollThreshold: 100, // percentage of viewport height

  // Add other GTM-related states here as needed
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
